<div class="div-title">
  <h1 mat-dialog-title>
    {{ data.title }}
  </h1>
</div>
<div class="fields" mat-dialog-content>
  <mat-form-field class="item edit-input edit-input-field" appearance="outline">
    <mat-label>{{data.textTitle}}</mat-label>
    <input type="text" matInput [(ngModel)]="data.textValue" [required]="true" />
  </mat-form-field>
  <br />
  <mat-form-field *ngIf="!data.hideNumberField" class="item edit-input edit-input-field" appearance="outline">
    <mat-label>{{data.numberTitle}}</mat-label>
    <input type="number" matInput [(ngModel)]="data.numberValue" />
  </mat-form-field>

</div>
<div class="div-buttons" mat-dialog-actions>
  <button class="btn" mat-raised-button color="primary"
    [disabled]="!data.textValue || (data.numberRequired && (!data.numberValue && data.numberValue !== 0))"
    (click)="closeDialog()">{{ data.buttonText }}</button>
  <button class="btn" mat-button (click)="cancelDialog()">Cancelar</button>
</div>